export default __webpack_public_path__ + "static/media/mssql.18f84630.svg";